// extracted by mini-css-extract-plugin
export default {"loading":"n6c054pmEgLPauvpFm9c"};